export default function RequestForm() {
  const setup = (form) => {
    const submit = form.querySelector('button[type="submit"]');

    const inputs = form.querySelectorAll('[required]');

    const onChange = (e) => {
      const input = e.target;

      if (input.value !== '' && !input.checkValidity()) {
        input.parentElement.classList.add('w-has-error');
      } else {
        input.parentElement.classList.remove('w-has-error');
      }
    };
    inputs.forEach((input) => {
      input.addEventListener('keyup', onChange);
    });

    const onSubmit = (e) => {
      e.preventDefault();

      let valid = true;
      inputs.forEach((input) => {
        if (!input.checkValidity()) {
          valid = false;
          input.parentElement.classList.add('w-has-error');
        }
      });

      if (!valid) return false;
      else form.submit();
    };
    submit.addEventListener('click', onSubmit);
  };

  return {
    init: () => {
      const form = document.querySelector('[data-w-form="request"]');
      if (!form) return;

      setup(form);
    },
  };
}
